export default {
  'failedImportDetails.displayFirstUploadErrors': 'Displaying first 100 upload errors only',
  'failedImportDetails.printMessage':
    'File details with import number <%= importNumber %> printed',
  'failedImportDetails.printGrid': 'Print <%= gridName %>'
};
